import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class AllIndicesListUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult() {
        return await this.repo.getAllIndicesList();
    }
}
export default AllIndicesListUseCase;
